'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionCompareArrows = function ActionCompareArrows(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z' })
  );
};
ActionCompareArrows = (0, _pure2.default)(ActionCompareArrows);
ActionCompareArrows.displayName = 'ActionCompareArrows';
ActionCompareArrows.muiName = 'SvgIcon';

exports.default = ActionCompareArrows;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/action/compare-arrows.js
// module id = 926
// module chunks = 0